module.exports = __webpack_public_path__ + "img/discount_background.ddd1122.png";